import React from 'react';

import { FieldArray } from 'react-final-form-arrays';

import { CheckboxInput } from '@vk-hr-tek/app-ui/form';
import { Box } from '@vk-hr-tek/ui/Box';

import { MultipleTextChoiceAnswerSettings } from '@app/gen/community';

import { ContentSurveysChoiceLabel } from '../ContentSurveysChoiceLabel';

interface ContentSurveysMultipleChoiceProps {
  fieldIndex: number;
  answerSettings: MultipleTextChoiceAnswerSettings;
}

export const ContentSurveysMultipleChoice = ({
  fieldIndex,
  answerSettings,
}: ContentSurveysMultipleChoiceProps) => {
  const name = `questions[${fieldIndex}]`;
  const { answer_options: answerOptions } = answerSettings;

  return (
    <Box display="flex" flexDirection="column" gap="12">
      <FieldArray
        name={`${name}.answer`}
        validate={(values) => {
          if (!values.some((value) => value.checked)) {
            return 'Обязательное поле';
          }
        }}
      >
        {({ fields }) =>
          fields.map((fieldName, index) => {
            const { checked } = fields.value[index];

            return (
              <Box
                key={index}
                py="12"
                paddingLeft="20"
                paddingRight="16"
                border={1}
                radius="m"
                borderColor={
                  checked ? 'original.brand.primary' : 'stroke.primary'
                }
                bgcolor="bg.light.primary"
                display="flex"
                flexDirection="column"
                gap="12"
              >
                <CheckboxInput
                  name={`${fieldName}.checked`}
                  withoutMargin
                  label={
                    <ContentSurveysChoiceLabel option={answerOptions[index]} />
                  }
                />
              </Box>
            );
          })
        }
      </FieldArray>
    </Box>
  );
};
